var map = {
	"./logo-todomath-for-web-cn@3x.png": "lQIB",
	"./logo-todomath-for-web-en@3x.png": "mUGf",
	"./logo-todomath-for-web-ja@3x.png": "vXfn",
	"./logo-todomath-for-web-ko@3x.png": "8qtw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dRg4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo ^\.\/logo\-todomath\-for\-web\-.*@3x\.png$
// module id = dRg4
// module chunks = 18